import { createSlice } from "@reduxjs/toolkit";

export const AuthSlice = createSlice({
    name:'auth',
    initialState: {
        token: ""
    },
    reducers: {
        updateToken: (state, action) => {
            return {
                ...state,
                token: action.payload.token
            }
        }
    }
})

export const { updateToken } = AuthSlice.actions

export default AuthSlice.reducer
